import {AS_BUSINESS_UNIT_TYPE} from '~/constants/businessUnit'

export const CUSTOMER_TYPES_SHAREHOLDER = 200000
export const AS_CUSTOMER_BUSINESS_UNIT_TYPE = AS_BUSINESS_UNIT_TYPE
